import { render } from "./RegisterView.vue?vue&type=template&id=5cf4469f"
import script from "./RegisterView.vue?vue&type=script&lang=js"
export * from "./RegisterView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__